"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePicker = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const theme_1 = require("../modules/theme");
const layout_1 = require("../modules/layout");
const validation_1 = require("../modules/validation");
class TimePicker extends React.Component {
    constructor() {
        super(...arguments);
        this.backspace = false;
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    paddingHorizontal: 16,
                    paddingVertical: 8,
                    borderWidth: 1,
                    borderColor: theme.borderColor1,
                    borderRadius: 3
                },
                label: {
                    color: theme.textColor2,
                    fontFamily: theme.fontFamily3,
                    fontSize: (0, layout_1.isTablet)() ? 15 : 12,
                    lineHeight: 16
                },
                input: {
                    color: theme.textColor1,
                    fontFamily: theme.fontFamily1,
                    fontSize: 16,
                    minHeight: 22,
                    padding: 0,
                    margin: 0,
                    outlineStyle: 'none'
                },
                readonly: {
                    backgroundColor: theme.disabledColor
                }
            });
            return styles;
        };
    }
    render() {
        const { label, style, disabled, value, nativeID } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.TouchableWithoutFeedback, { accessible: false, disabled: disabled, ref: ref => 
            //@ts-ignore
            ref && ref.setNativeProps && ref.setNativeProps({ tabIndex: -1 }) },
            React.createElement(react_native_1.View, { style: [styles.container, style, !disabled ? null : styles.readonly] },
                React.createElement(react_native_1.Text, { style: styles.label }, label),
                React.createElement(react_native_1.TextInput, { nativeID: nativeID, value: value, style: styles.input, maxLength: 5, onKeyPress: (e) => {
                        if (e.nativeEvent.key === 'Backspace') {
                            this.backspace = true;
                        }
                    }, onChangeText: (text) => {
                        if (value.length > 0 && value.match(/[a-zA-Z]+/) == null) {
                            if (text.length === 2 && !this.backspace) {
                                text += ':';
                            }
                            if (text.length === 3 && !text.includes(':')) {
                                text = text.substr(0, 2) + ':' + text.substr(2);
                            }
                            if (text.length <= 2) {
                                this.backspace = false;
                            }
                            if ((0, validation_1.isHour)(text + '00:00'.substr(text.length))) {
                                this.props.onChange(text);
                            }
                        }
                        else {
                            this.props.onChange(text);
                        }
                    }, onBlur: () => {
                        if (value.length > 0 && value.match(/[a-zA-Z]+/) == null) {
                            this.props.onChange(value + '00:00'.substr(value.length));
                        }
                    } }))));
    }
}
exports.TimePicker = TimePicker;
TimePicker.defaultProps = {
    disabled: false
};
